/**
 * Inline-SVG card-network marks for the footer payment strip.
 * Self-contained (no icon font / remote asset) because Maestro and RuPay have
 * no Font Awesome / react-icons glyph. Each sits on a white rounded chip so the
 * brand colors stay legible over the dark footer. viewBox 48×32 → 1.5 ratio.
 */

function Chip({ label, children }) {
  return (
    <svg className="ft-card" viewBox="0 0 48 32" role="img" aria-label={label} xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="32" rx="4" fill="#fff" />
      {children}
    </svg>
  )
}

function Visa() {
  return (
    <Chip label="Visa">
      <text x="24" y="21" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontSize="13" fontStyle="italic" fontWeight="700" letterSpacing="1" fill="#1A1F71">VISA</text>
    </Chip>
  )
}

function Mastercard() {
  return (
    <Chip label="Mastercard">
      <circle cx="20" cy="16" r="9" fill="#EB001B" />
      <circle cx="28" cy="16" r="9" fill="#F79E1B" />
      {/* lens where the two circles overlap */}
      <path d="M24 7.94A9 9 0 0 1 24 24.06 9 9 0 0 1 24 7.94Z" fill="#FF5F00" />
    </Chip>
  )
}

function Maestro() {
  return (
    <Chip label="Maestro">
      <circle cx="20" cy="16" r="9" fill="#0099DF" />
      <circle cx="28" cy="16" r="9" fill="#ED0006" />
      <path d="M24 7.94A9 9 0 0 1 24 24.06 9 9 0 0 1 24 7.94Z" fill="#7A3E8E" />
    </Chip>
  )
}

function RuPay() {
  return (
    <Chip label="RuPay">
      <text x="24" y="20" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontSize="11" fontWeight="800" letterSpacing="0.2">
        <tspan fill="#E97626">Ru</tspan>
        <tspan fill="#00539F">Pay</tspan>
      </text>
    </Chip>
  )
}

/** Ordered list rendered by the footer payment strip. */
export const CARD_ICONS = [
  { name: 'Visa', Icon: Visa },
  { name: 'Mastercard', Icon: Mastercard },
  { name: 'Maestro', Icon: Maestro },
  { name: 'RuPay', Icon: RuPay },
]
